export default __webpack_public_path__ + "static/media/user-icon.7c54e2cd.svg";